import Layout from '../../components/layout/Layout'
import FocusRuler from '../../components/ui/focus-ruler'

const ThoughtRuler = () => {
  return (
    <Layout>
      <div className="w-full max-w-4xl px-4 md:px-8 lg:px-12 py-12 space-y-6">
        <h1 className="text-[2.488rem] font-semibold text-foreground font-sans tracking-[-0.025em] leading-[1.2] [text-wrap:balance]">
          Zoomable Graph
        </h1>
        
        

        <div className="mt-8 max-w-md mx-auto">
          <FocusRuler />
        </div>

      </div>
    </Layout>
  )
}

export default ThoughtRuler 